// components/organisms/Navbar/Navbar.js
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const NavLink = ({ page, className, onClick, children }) =>
    page.isNavGroup
        ? <span className={`${className} navbar-link--group-label`}>{children}</span>
        : <a href={page.url} className={className} onClick={onClick}>{children}</a>;

const DropdownLink = ({ page, className }) =>
    page.isNavGroup
        ? <span className={`${className} navbar-dropdown-link--group-label`}>{page.title}</span>
        : <a href={page.url} className={className}>{page.title}</a>;

const Navbar = ({ primaryPages = [] }) => {
    const [openDropdown, setOpenDropdown] = useState(null);
    const navRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (navRef.current && !navRef.current.contains(e.target)) {
                setOpenDropdown(null);
            }
        };
        const handleEscape = (e) => {
            if (e.key === 'Escape') setOpenDropdown(null);
        };
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleEscape);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleEscape);
        };
    }, []);

    const handleToggle = (pageId) => {
        setOpenDropdown(openDropdown === pageId ? null : pageId);
    };

    return (
        <nav className="navbar" ref={navRef}>
            <ul className="navbar-nav">
                {primaryPages.map((page) => (
                    <li
                        key={page.id}
                        className={`navbar-item ${openDropdown === page.id ? 'is-open' : ''}`}
                    >
                        <NavLink
                            page={page}
                            className="navbar-link"
                            onClick={(e) => {
                                if (page.secondaryPages?.length > 0) {
                                    e.preventDefault();
                                    handleToggle(page.id);
                                }
                            }}
                        >
                            {page.title}
                            {page.secondaryPages?.length > 0 && (
                                <span className="nav-chevron nav-chevron--down" aria-hidden="true" />
                            )}
                        </NavLink>
                        {page.secondaryPages?.length > 0 && (
                            <ul className={`navbar-dropdown ${openDropdown === page.id ? 'is-open' : ''}`}>
                                {page.secondaryPages.map((subPage) => (
                                    <li key={subPage.id}>
                                        <DropdownLink page={subPage} className="navbar-dropdown-link" />
                                    </li>
                                ))}
                            </ul>
                        )}
                    </li>
                ))}
            </ul>
        </nav>
    );
};

Navbar.propTypes = {
    primaryPages: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        title: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
        isNavGroup: PropTypes.bool,
        secondaryPages: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
            title: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
            isNavGroup: PropTypes.bool,
        })),
    })),
};

export default Navbar;